import videojs from 'video.js';